type SearchParamsLike = string | URLSearchParams;

const toSortedEntries = (value: SearchParamsLike): [string, string][] => {
  const params = typeof value === 'string' ? new URLSearchParams(value) : value;

  return Array.from(params.entries()).sort(([leftKey, leftValue], [rightKey, rightValue]) => {
    const keyComparison = leftKey.localeCompare(rightKey);

    return keyComparison === 0 ? leftValue.localeCompare(rightValue) : keyComparison;
  });
};

export const normaliseSearchParams = (value: SearchParamsLike): string =>
  new URLSearchParams(toSortedEntries(value)).toString();

export const areSearchParamsEquivalent = (left: SearchParamsLike, right: SearchParamsLike): boolean =>
  normaliseSearchParams(left) === normaliseSearchParams(right);
